<template>
<div class="score-dancing">
    <div class="score-dancing-original">
        <div v-for="(step, beat) in phrase" :key="'Beat-' + beat" :id="'Beat-' + beat" class="beat caixa">
            <div v-show="beat === 0 || step.name === 'Clap' || (beat >= 1 && phrase[beat-1].name !== step.name)" :class="'dance-step ' + {'play-beat': playing}" :disabled="disable || (step.name === 'Clap' && (beat >= 1 && phrase[beat-1].name === 'Clap'))" :id="'Dance-' + beat" @click="next_option(beat)">
                <LottieAnimation :name="step.name.replaceAll(' ', '-') + '-' + beat" :path="'dance-steps/' + step.name.replaceAll(' ', '-') + '.json'" class="animation" />
                <!--<h4 class="step-description">{{step.name}}</h4>-->
            </div>
        </div>
    </div>
</div>
</template>

<script>
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue";

export default {
    name: 'PhraseDisplay',
    emits: ['changed_step'],
    components: {
        LottieAnimation

    },
    props: {
        phrase: Object,
        levels: Object,
        alternatives: Object,
        disable: Boolean,
        playing: Boolean

    },
    data() {
        return {
            hovering: {},
            colors: {}
        }
    },
    methods: {
        next_option(beat) {
            let i = this.alternatives.map((el) => {
                return el.name
            }).indexOf(this.phrase[beat].name);

            let opt = this.alternatives[0];
            if (i < this.alternatives.length - 1) {
                opt = this.alternatives[i + 1];
            }
            this.$emit('changed_step', [beat, opt]);
        },
        setAnimController(e) {
            console.log(e);
        }
    }
}
</script>

<style>
.animation {

    /*width: 6.5rem !important;  */

}

.score-dancing {
    width: 100%;
    display: flex;
    /*justify-items: start;
    align-items: start;*/
}

.score-dancing-original {
    width: 100%;
    display: flex;
}

.beat-score {
    /*border: solid 1px coral;*/
    width: 70%;
    display: flex;
    justify-items: center;
    align-items: center;
}

.dance-step {
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 1em;
    /* padding: 0.25em;*/
}

.dance-step[disabled=true] {
    background: none !important;
    pointer-events: none;
}

.dance-step.playing {
    opacity: 0.0;
}

.beat.playing-step {
    z-index: 1000;
    background-color: rgba(255, 255, 255, 1) !important;
    border-radius: 5%;
    top: 20% !important;
    height: 40% !important;
    padding: 1em !important;
    display: flex !important;
    align-content: center;
    justify-content: space-between;
    align-items: center;
}

.beat.next-playing-step>.dance-step,
.beat.playing-step>.dance-step {
    opacity: 1.0 !important;
}

.beat.next-playing-step {
    opacity: 1.0;
    top: 25% !important;
    height: 80% !important;
    padding: 1em !important;
    display: flex !important;
    align-content: flex-end;
}

.beat.playing-step>.dance-step>.animation {
    width: 200%;
}

.step-description {}

.lyc-score {
    width: 70%;
    display: flex;
    justify-content: space-around;
    flex-direction: row;
    align-content: center;
    align-items: center
}

.note-dancing {
    margin: 0-0.8rem;
}

.note-dancing>img {
    width: 5rem;
}

.lyric-dancing {
    font-family: Omnes;
    font-weight: bold;
    font-style: normal;
    font-size: 1.5rem;

    color: #CCECF9;
    text-align: center;
    vertical-align: middle;
}

.choose-dancing {
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 1em;
    height: 3.2em;
    padding: 0.65em 0.9em;
}

/*
.instrument {
    display: flex;
    justify-content: flex-start;

    margin-top: 1.8em;
}

.instrument-selector {
    background: rgba(255, 255, 255, 0.8);
    border-radius: 50%;

    display: flex;
    justify-content: space-around;

    margin-left: 1em;
    z-index: 1;
}

.instrument-selector:active {
    background: red;
}
 */

@media only screen and(max-width: 480 px) {
    .choose-dancing {
        padding: 0.5rem;
        border-radius: 8px;
    }

    .note-dancing {
        margin: 0-0.7rem;
    }

    .note-dancing>img {
        width: 2rem;
    }

    .hidden-melody {
        height: 3.9rem;
        width: 1.3rem;
    }
}

@media only screen and(min-width: 480px) and(max-width: 550px) {
    .beat-dancing {
        padding: 0.5rem;
        border-radius: 8px;
    }

    .note-dancing {
        margin: 0-0.7rem;
    }

    .note-dancing>img {
        width: 2.8rem;
    }

    .hidden-melody {
        height: 3.9rem;
        width: 1.3rem;
    }
}

@media only screen and(min-width: 480px) and(max-width: 550px) {
    .beat-dancing {
        padding: 0.6rem;
        border-radius: 9px;
    }

    .note-dancing {
        margin: 0-0.8rem;
    }

    .note-dancing>img {
        width: 3rem;
    }

    .hidden-melody {
        height: 4rem;
        width: 1.4rem;
    }
}

@media only screen and(min-width: 550px) and(max-width: 630px) {
    .beat-dancing {
        padding: 0.7rem;
        border-radius: 10px;
    }

    .note-dancing {
        margin: 0-0.9rem;
    }

    .note-dancing>img {
        width: 3.4rem;
    }

    .hidden-melody {
        height: 4.3rem;
        width: 1.6rem;
    }
}

@media only screen and(min-width: 630px) and(max-width: 718px) {
    .beat-dancing {
        padding: 0.8rem;
        border-radius: 11px;
    }

    .note-dancing {
        margin: 0-1rem;
    }

    .note-dancing>img {
        width: 3.6rem;
    }

    .hidden-melody {
        height: 4.6rem;
        width: 1.6rem;
    }
}

@media only screen and(min-width: 718 px) and(max-width: 806 px) {
    .beat-dancing {
        padding: 0.9rem;
        border-radius: 12px;
    }

    .note-dancing {
        margin: 0-1.1rem;
    }

    .note-dancing>img {
        width: 4rem;
    }

    .hidden-melody {
        height: 5.1rem;
        width: 1.7rem;
    }
}

@media only screen and(min-width: 806 px) and(max-width: 1024 px) {
    .beat-dancing {
        padding: 1rem;
        border-radius: 13px;
    }

    .note-dancing {
        margin: 0-1.2rem;
    }

    .note-dancing>img {
        width: 4.4rem;
    }

    .hidden-melody {
        height: 5.5rem;
        width: 2rem;
    }
}

@media only screen and(min-width: 1024 px) and(max-width: 1200 px) {
    .beat-dancing {
        padding: 1.2 rem;
        border-radius: 14 px;
    }

    .note-dancing {
        margin: 0-1.5 rem;
    }

    .note-dancing>img {
        width: 6 rem;
    }

    .hidden-melody {
        height: 7.5 rem;
        width: 2.9 rem;
    }
}

@media only screen and(min-width: 1200 px) and(max-width: 1366 px) {
    .beat-dancing {
        padding: 1.4 rem;
        border-radius: 15 px;
    }

    .note-dancing {
        margin: 0-1.7 rem;
    }

    .note-dancing>img {
        width: 6.6 rem;
    }

    .hidden-melody {
        height: 8.2 rem;
        width: 3.1 rem;
    }
}

@media only screen and(min-width: 1366 px) and(max-width: 1540 px) {
    .beat-dancing {
        padding: 1.6 rem;
        border-radius: 16 px;
    }

    .note-dancing {
        margin: 0-1.9 rem;
    }

    .note-dancing>img {
        width: 7.4 rem;
    }

    .hidden-melody {
        height: 9.2 rem;
        width: 3.3 rem;
    }
}

@media only screen and(min-width: 1540 px) and(max-width: 1680 px) {
    .beat-dancing {
        padding: 1.8 rem;
        border-radius: 20 px;
    }

    .note-dancing {
        margin: 0-2 rem;
    }

    .note-dancing>img {
        width: 8.5 rem;
    }

    .hidden-melody {
        height: 10.5 rem;
        width: 4 rem;
    }
}

@media only screen and(min-width: 1680 px) and(max-width: 2350 px) {
    .beat-dancing {
        padding: 2 rem;
        border-radius: 25 px;
    }

    .note-dancing {
        margin: 0-2.3 rem;
    }

    .note-dancing>img {
        width: 9.3 rem;
    }

    .hidden-melody {
        height: 11.5 rem;
        width: 4.7 rem;
    }
}

@media only screen and(min-width: 2350 px) {
    .buttons-melody>div {
        width: 5.4 rem;
    }

    .lateral-melody {
        width: 5.3 rem;
    }

    .beat-dancing {
        padding: 2.2 rem;
        border-radius: 30 px;
    }

    .note-dancing {
        margin: 0-3 rem;
    }

    .note-dancing>img {
        width: 13 rem;
    }

    .hidden-melody {
        height: 16 rem;
        width: 7.2 rem;
    }
}
</style>
